import { render, staticRenderFns } from "./ViewLetter.vue?vue&type=template&id=50db9e48&scoped=true&"
import script from "./ViewLetter.vue?vue&type=script&lang=ts&"
export * from "./ViewLetter.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLetter.vue?vue&type=style&index=0&id=50db9e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db9e48",
  null
  
)

export default component.exports